import React, { useState, useEffect, useRef } from "react";
import Navbar from "./component/Navbar";
import Hero from "./component/Hero";
import Features from "./component/Features";
import Grid from "./component/Grid";  // PalmFeatures section
import CardSlider from "./component/CardSlider";
import VideoSection from "./component/VideoSection";
import FAQSection from "./component/Faqsection";
import SubscribeSection from "./component/SubscribeSection";
import Footer from "./component/Footer";

import "./App.css";

function App() {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Detect mobile screen
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // breakpoint for mobile
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      const handleLoadedMetadata = () => {
        video.currentTime = 0;
        video.play();
      };

      const handleEnded = () => {
        setLoading(false); // Show main content when video ends
      };

      video.addEventListener("loadedmetadata", handleLoadedMetadata);
      video.addEventListener("ended", handleEnded);

      return () => {
        video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        video.removeEventListener("ended", handleEnded);
      };
    }
  }, []);

return ( <div className="App"> {loading ? ( <div id="preloader"> 
<video ref={videoRef} src={isMobile ? "/MobileGridVideo.mp4" : "/GridVideo.mp4"}
 autoPlay muted playsInline preload="auto" loop={false} 
 className="preloader-video" /> </div>
      ) : (
        <div className="backgroundWrapper">
          <Navbar />
          <Hero />
          <Features />
          <Grid />  {/* has id="palm-features" */}
          <CardSlider />
          <VideoSection />
          <FAQSection />
          <SubscribeSection />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
